import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import { Provider } from 'react-redux'
import store from './redux'
import theme from './theme'
import { registerSW } from 'virtual:pwa-register' // We'll need to add vite-plugin-pwa for this

// Initialize PWA service worker
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  registerSW()
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
)